import { oneOf } from '@/components/Internal/DataTable'

const JOB_STATES = ['waiting', 'active', 'completed', 'failed', 'delayed']

export const queueListFilters = {
  status: oneOf<string | undefined>(JOB_STATES, undefined),
}
